// Vendors
import { TimerEnumeration } from '@gruposantander/opbpay-ui-core-models';
// Event Handlers
import { canFetchStateAgainByTimeout } from './utils/get-state.handlers.utils';
// Types
import {
  GetStateBuilderHandlersType,
  GetStateMethodsHandlersType,
} from './types/get-state.handlers.type';
// Utilities
import { getCurrentOnboardingStateResolver } from 'resolvers/get-state.resolver';

const manageInternalStateGet = async ({
  onError,
  onSuccess,
}: Pick<GetStateBuilderHandlersType, 'onError' | 'onSuccess'>): Promise<boolean | undefined> => {
  const [response, error] = await getCurrentOnboardingStateResolver();

  if (response) {
    onSuccess(response);
  } else {
    onError();
  }

  return error;
};

const getOnboardingStateEventHandler = async ({
  attempts = 0,
  onError,
  timeout,
  timeoutRef,
  isMountedRef,
  customPullingInterval,
  ...props
}: GetStateBuilderHandlersType): Promise<void> => {
  if (timeout) {
    if (canFetchStateAgainByTimeout({ attempts, timeout })) {
      // Los intentos de fetch son menores al timeout con el que se ha configurado el servicio
      timeoutRef.current = setTimeout(async () => {
        // Comprueba que sigue en el hook antes de ejecutar la siguiente llamada
        if (isMountedRef && !isMountedRef.current) {
          return;
        }
        const error = await manageInternalStateGet({ ...props, onError }); // Se llama al get del estado
        if (!error) {
          // No parabamos el timeout si habia error
          getOnboardingStateEventHandler({
            ...props,
            attempts: attempts + 1,
            onError,
            timeout,
            timeoutRef,
            isMountedRef,
            customPullingInterval,
          });
        }
      }, customPullingInterval ?? TimerEnumeration.TIMEOUT_ONE_SECOND);
    } else {
      // Se ha superado por tanto se cierra el intervalo
      onError();
    }
  } else {
    // No tiene timeout
    await manageInternalStateGet({ ...props, onError });
  }
};

const cleanupIntervalsOnUnmountHookHandler = ({
  isMountedRef,
  timeoutRef,
}: GetStateBuilderHandlersType): void => {
  isMountedRef.current = false;
  clearTimeout(timeoutRef.current);
};

const GetStateHandlers = (props: GetStateBuilderHandlersType): GetStateMethodsHandlersType => ({
  handleCleanupIntervalsOnUnmount: () => cleanupIntervalsOnUnmountHookHandler(props),
  handleGetOnboardingStateEvent: () => getOnboardingStateEventHandler(props),
});

export { GetStateHandlers };
